export default __webpack_public_path__ + "static/media/avatar-2.c8cc71c9.png";